<template>
  <a-drawer width="35%" :label-col="4" :wrapper-col="14" :visible="open" @cancel="onClose" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :label-col="labelCol" :wrapper-col="wrapperCol" :model="form"  :rules="rules">
      <a-form-model-item prop="payUserNickName" >
        <span slot="label" >
          <a-tooltip>
            {{$t('打赏用户')}}<template slot="title">{{$t('打赏用户')}}</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.payUserNickName"  :placeholder="$t('通用.输入.请输入')+$t('打赏用户')" />
      </a-form-model-item>
      <a-form-model-item prop="sourceId" >
        <span slot="label" >
          <a-tooltip>
            {{$t('视频打赏记录.打赏视频ID')}}<template slot="title">{{$t('视频打赏记录.打赏视频ID')}}</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.sourceId"  :placeholder="$t('通用.输入.请输入')+$t('视频打赏记录.打赏视频ID')" />
      </a-form-model-item>
      <a-form-model-item prop="giveUserId" >
        <span slot="label" >
          <a-tooltip>
            {{$t('视频打赏记录.收益人，0为平台')}}<template slot="title">{{$t('视频打赏记录.收益人，0为平台')}}</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.giveUserId"  :placeholder="$t('通用.输入.请输入')+$t('视频打赏记录.收益人，0为平台')" />
      </a-form-model-item>
      <a-form-model-item prop="giftCount" >
        <span slot="label" >
          <a-tooltip>
            {{$t('视频打赏记录.礼物数量')}}<template slot="title">{{$t('视频打赏记录.礼物数量')}}</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.giftCount"  :placeholder="$t('通用.输入.请输入')+$t('视频打赏记录.礼物数量')" />
      </a-form-model-item>
      <a-form-model-item prop="remark" >
        <span slot="label" >
          <a-tooltip>
            {{$t('视频打赏记录.备注')}}<template slot="title">{{$t('视频打赏记录.备注')}}</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.remark" :placeholder="$t('通用.输入.请输入')" type="textarea" allow-clear />
      </a-form-model-item>
      <a-modal :visible="previewImageVisible" :footer="null" @cancel="previewImageCancel">
        <img alt="example" style="width: 100%" :src="previewUrl" />
      </a-modal>
      <a-modal :visible="previewVideoVisible" :footer="null" @cancel="previewVideoCancel">
        <video style="width: 100%" :src="previewUrl" ref="myVideo"
               :poster="previewUrl + '?x-oss-process=video/snapshot,t_0,f_jpg'" :controls="true"></video>
      </a-modal>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            {{$t('通用.按钮.保存')}}
          </a-button>
          <a-button type="dashed" @click="cancel">
            {{$t('通用.按钮.取消')}}
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getRewardLog, addRewardLog, updateRewardLog } from '@/api/video/rewardLog'
import {mapGetters} from 'vuex'
import CustomDictTag from "@/components/DictCustomTag";
import {generateFilePath, uploadObject} from "@/api/tool/oss";


export default {
  name: 'CreateForm',
  props: {
  },
  components: {
    CustomDictTag,
  },
  data () {
    return {
      labelCol: { span: 4 },
      wrapperCol: { span: 14 },
      submitLoading: false,
      formTitle: '',
      previewImageVisible: false,
      previewUrl: '',
      previewVideoVisible: false,
      loading: '',
      // 表单参数
      form: {
        id: null,

        payUserNickName: null,

        sourceId: null,

        giveUserId: null,

        giftCount: null,

        createTime: null,

        remark: null,

      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
        userId: [
          { required: true, message: this.$t('打赏用户')+this.$t('通用.文本.不能为空'), trigger: 'blur' }
        ],
        sourceId: [
          { required: true, message: this.$t('视频打赏记录.打赏视频ID')+this.$t('通用.文本.不能为空'), trigger: 'blur' }
        ],
        giveUserId: [
          { required: true, message: this.$t('视频打赏记录.收益人，0为平台')+this.$t('通用.文本.不能为空'), trigger: 'blur' }
        ]
      }
    }
  },
  filters: {
  },
  created () {
  },
  computed: {
    ...mapGetters(['customDict'])
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    onClose () {
      this.open = false
      this.reset()
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    previewImageCancel() {
      this.previewImageVisible = false;
    },
    previewVideoCancel() {
      this.previewVideoVisible = false;
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.form = {
        id: null,
        userId: null,
        sourceId: null,
        giveUserId: null,
        giftCount: null,
        createTime: null,
        remark: null,
      }

    },
    /** 新增按钮操作 */
    handleAdd (row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = this.$t('通用.文本.添加')
    },
    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getRewardLog({"id":id}).then(response => {
        this.form = response.data
        this.open = true
        this.formTitle = this.$t('通用.文本.修改')
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          let message = '';
          if (this.form.id !== undefined && this.form.id !== null) {
            message = this.$t('通用.文本.修改成功')
            updateRewardLog(this.form).then(response => {
              this.$message.success(
                message,
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            message = this.$t('通用.文本.修改成功')
            addRewardLog(this.form).then(response => {
              this.$message.success(
                message,
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
